import styled from 'styled-components';
import { ActionPanel } from 'components/molecules/action-panel';

const { PopoverAction, ConfirmationPopover, Action } = ActionPanel;

export const DeletePopoverAction = styled(PopoverAction).attrs({
  hideChevron: true,
})`
  ${Action} {
    color: var(--error-color);
    --action-hover-background: var(--ozone-red-surface);
  }
`;

export const DeletePopover = styled(ConfirmationPopover)`
  .ant-btn-link {
    color: var(--error-color);
  }
`;
